module["exports"] = [
  "Phd."
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/sk/name/suffix.js
// module id = 1336
// module chunks = 0